import { useContext, createContext } from 'react';
import { DataTypeType } from 'modules/domains';
import noop from 'utils/noop';
import { FieldSearchOption } from '../../../types';

export type SearchFieldContextState = {
  option: FieldSearchOption | null;
  changeOption: (option: FieldSearchOption | null) => void;
  changeDataType: (dataType?: DataTypeType) => void;
  dataType?: DataTypeType;
};

export const defaultState = {
  option: null,
  changeOption: noop,
  changeDataType: noop,
};

export const SearchFieldContext = createContext<SearchFieldContextState>(defaultState);
export const useSearchFieldContext = () => useContext(SearchFieldContext);
